/**
 * Maps Attio engagement type (`valuationType`) to the Dropbox valuation folder name prefix.
 * Source: Folder naming conventions spreadsheet (Engagement Type → Folder name).
 *
 * ESOP and Commercialization Model use the engagement category label as `valuationType` when Attio has no separate type.
 *
 * Subscription: sheet indicates no default Dropbox folder — prefix is empty so the UI suggests date-only.
 */
export const VALUATION_TYPE_FOLDER_PREFIX: Record<string, string> = {
  '409A': 'IRC 409A',
  'ASC 718': 'ASC 718',
  'Board Advisory': 'Board Advisory',
  'Consulting': 'Transfer Pricing',
  'Contingent Consideration (ASC 450)': 'ASC 450',
  'Convertible Note - Conversion Feature': 'ASC 815',
  'Convertible Note - Entire Note': 'ASC 815',
  'Common Stock - Canada': 'Common Stock - Canada',
  'Common Stock - Other Tax/Financial Reporting Purposes': 'Common Stock',
  'Commercialization Model': 'Commercialization Model',
  'Debt Valuation': 'Debt Valuation',
  'Entity Conversion': 'Entity Conversion',
  'ESOP': 'ESOP Valuation',
  'Enterprise/Equity Valuation - Capital Raise': 'Consulting',
  'Enterprise/Equity Valuation - Shareholder Buyout': 'Consulting',
  'Enterprise/Equity Valuation - Transaction Negotiation': 'Consulting',
  'Equity - PE': 'ASC 820',
  'Equity - VC': 'ASC 820',
  'Fairness Opinion': 'Fairness Opinion',
  'Fixed Asset Appraisal': 'Fixed Asset Appraisal',
  'Full Study': 'Transfer Pricing',
  'Generic': 'Consulting',
  'Goodwill Impairment (ASC 350)': 'ASC 350',
  'GP Services': 'Consulting',
  'Impairment (IAS 36)': 'IAS 36',
  'Incremental Borrowing Rate': 'Debt Valuation',
  'Intellectual Property': 'Intellectual Property',
  'Intangible Asset Impairment (ASC 360)': 'ASC 360',
  'Letter of Opinion': 'Letter of Opinion',
  'Marital Dissolution': 'Marital Dissolution',
  'Mini Study': 'Transfer Pricing',
  'Misc': 'Derivative',
  'Noncash Charitable Contribution (Form 8283)': 'IRS 8283',
  'Other': 'G&E',
  'Other Litigation': 'Other Litigation',
  'Performance Based Options (ASC 718)': 'ASC 718',
  'Phantom Stock': 'Phantom Stock',
  'Portfolio Company': 'Portfolio',
  'PPA (ASC)': 'ASC 805',
  'PPA (IFRS 3)': 'IFRS 3',
  'Profits Interests - Expensing Previous Grants': 'Profits Interests',
  'Profits Interests - Setting Threshold': 'Profits Interests',
  'SBA 7(a)': 'SBA 7(a)',
  'Section 1202 (QSBS)': 'QSBS',
  'Shareholder Disputes': 'Shareholder Disputes',
  'Solvency Opinion': 'Solvency Opinion',
  'Subscription': '',
  'Tax Valuation (Generic)': 'Tax Valuation (Generic)',
  'Token Valuation': 'Token Valuation',
  'Transfer': 'G&E',
  'Underlying Securities': 'ASC 815',
  'Warrant': 'ASC 815',
};

export const getValuationFolderNamePrefix = (valuationType: string | null | undefined): string => {
  const key = valuationType?.trim();
  if (!key) {
    return '';
  }
  const mapped = VALUATION_TYPE_FOLDER_PREFIX[key];
  return typeof mapped === 'string' ? mapped : '';
};
